<div 
    *ngIf="element === 'ticket'" class="lg:w-[141px] lg:h-[110px] w-[114px] h-[90px] rounded-lg bg-primary-500 p-[30px] text-center">
    <fa-icon [icon]="faTicket" class="lg:text-[30px] text-[20px] text-white"></fa-icon>
</div> 
<div 
    *ngIf="element === 'imageListV'" class="
    xl:w-[276px] xl:h-[207px] xl:p-[60px]
    lg:w-[227px] lg:h-[170px] lg:p-[40px]
    max-[300px]:w-[85vw] max-[300px]:h-[50vw] max-[300px]:p-[10vw]
    w-[276px] h-[207px] 
    rounded-lg bg-primary-500 p-[60px] text-center">
    <fa-icon [icon]="faImage" class="text-[60px] max-[300px]:text-[20vw] text-white"></fa-icon>
</div> 
<div 
    *ngIf="element === 'imageListH'" class="w-[96px] max-h-[96px] rounded-lg bg-primary-500 p-[30px] text-center">
    <fa-icon [icon]="faImage" class="text-[25px] text-white"></fa-icon>
</div> 
<div 
    *ngIf="element === 'topItems'" class="w-[84px] h-[56px] rounded-sm bg-primary-500 p-[15px] text-center">
    <fa-icon [icon]="faImage" class="text-[20px] text-white"></fa-icon>
</div> 
<div 
    *ngIf="element === 'imageFull'" class="w-[340px] min-h-[245px] max-h-[272px] rounded-lg bg-primary-500 p-[80px] text-center">
    <fa-icon [icon]="faImage" class="lg:text-[80px] text-[80px] text-white"></fa-icon>
</div> 